import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Pagination from 'react-js-pagination';
import { ListingCard } from '../../components/listing-card';
export function Listings(props) {
    const { listings, page, itemsCountPerPage, totalItemsCount, updatePage } = props;
    if (!listings.length) {
        return (_jsx("div", { className: "error-message", children: "No results found" }));
    }
    return (_jsxs("div", { className: "listings", children: [_jsx("div", { className: "listings-grid", children: listings.map((listing, index) => (_jsx(ListingCard, { listing: listing }, index))) }), totalItemsCount > itemsCountPerPage ?
                _jsx("div", { className: "listings-pagination", children: _jsx(Pagination, { activePage: page, itemsCountPerPage: itemsCountPerPage, totalItemsCount: totalItemsCount, pageRangeDisplayed: 4, onChange: updatePage, prevPageText: "<", nextPageText: ">", itemClass: "pagination-item" }) }) :
                null] }));
}
